import { Copy, Check } from 'lucide-react';
import { useState } from 'react';

interface BibTeXSectionProps {
  bibtexEntry: string;
}

const BibTeXSection: React.FC<BibTeXSectionProps> = ({ bibtexEntry }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    if (navigator.clipboard) {
      navigator.clipboard
        .writeText(bibtexEntry)
        .then(() => {
          setCopied(true);
          setTimeout(() => setCopied(false), 2000);
        })
        .catch((err) => {
          console.error('Failed to copy with Clipboard API:', err);
        });
    } else {
      const textArea = document.createElement('textarea');
      textArea.value = bibtexEntry;
      document.body.appendChild(textArea);
      textArea.select();
      try {
        document.execCommand('copy');
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
      } catch (err) {
        console.error('Failed to copy using document.execCommand:', err);
      }
      document.body.removeChild(textArea);
    }
  };

  return (
    <section className="py-16 bg-white text-black dark:bg-neutral-900 dark:text-white">
      <h2 className="text-4xl text-center font-extrabold tracking-tight mb-6">
        Citation
      </h2>
      <div className="relative flex justify-center items-center">
        <div className="relative w-full md:w-3/4 lg:w-2/3">
          <button
            onClick={handleCopy}
            className="absolute top-2 right-2 p-2 rounded hover:bg-gray-200 dark:hover:bg-gray-700 transition"
            aria-label="Copy BibTeX"
          >
            {copied ? (
              <Check className="w-5 h-5 text-green-500" />
            ) : (
              <Copy className="w-5 h-5" />
            )}
          </button>
          <pre className="bg-gray-100 dark:bg-gray-800 p-4 rounded text-sm font-mono whitespace-pre overflow-x-auto leading-snug">
            {bibtexEntry}
          </pre>
        </div>
      </div>
    </section>
  );
};

export default BibTeXSection;
